<template>
  <el-form
    ref="scheduleForm"
    :model="scheduleForm"
    :rules="rules"
  >
    <el-row>
      <el-col
        class="hidden-xs-only"
        style="width:20px"
      >&nbsp;</el-col>
      <el-col
        :span="6"
        :xs="6"
      >
        <el-form-item
          class="timepicker-col"
          prop="day"
        >
          <el-select
            v-model="scheduleForm.day"
            placeholder="请选择"
            size="small"
            :disabled="true"
            @change='dayChanged'
          >
            <el-option
              v-for="item in daysOfWeek"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        :span="6"
        :xs="7"
      >
        <el-form-item
          class="timepicker-col"
          prop="startTime"
        >
          <el-select
            v-model="scheduleForm.startTime"
            :disabled="scheduleForm.day==''"
            size="small"
            placeholder="开始时间"
            @focus="onStartTimeFocus()"
            @change="startTimeChanged"
          >
            <el-option
              v-for="item in timesOfStartTime"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        :span="6"
        :xs="7"
      >
        <el-form-item
          class="timepicker-col"
          prop="endTime"
        >
          <el-select
            v-model="scheduleForm.endTime"
            :disabled="scheduleForm.day==''"
            size="small"
            placeholder="结束时间"
            @focus="onEndTimeFocus()"
            @change="endTimeChanged"
          >
            <el-option
              v-for="item in timesOfEndTime"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<style lang="scss" scoped>
.timepicker-col {
  width: auto;
}
</style>

<script>
import { srcDaysOfWeek, srcTimesOfDay } from "@/service/api-base.service";
import { getStore } from "@/config/mUtils";

export default {
  props: [
    "rowIndex",
    "scheduleForm",
    "currentSchedulesAll"
  ],
  data() {
    let _self = this;
    let startTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择开始时间"));
      } else if (_self.scheduleForm.endTime !== "") {
        let timeSpan = parseInt(_self.scheduleForm.endTime) - parseInt(value);
        if (timeSpan < _self.courseSpan) {
          return callback(new Error("时间跨度至少应为1小时"));
        }
        return callback();
      } else {
        return callback();
      }
    };
    let endTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择结束时间"));
      } else if (_self.scheduleForm.startTime !== "") {
        let timeSpan = parseInt(value) - parseInt(_self.scheduleForm.startTime);
        if (timeSpan < _self.courseSpan) {
          return callback(new Error("时间跨度至少应为1小时"));
        }
        return callback();
      } else {
        return callback();
      }
    };

    return {
      courseSpan: 60,
      daysOfWeek: [],
      selfTimeLeft: 0,
      timesOfDay: srcTimesOfDay(false),
      timesOfStartTime: srcTimesOfDay(false),
      timesOfEndTime: srcTimesOfDay(false),
      rules: {
        startTime: [
          {
            validator: startTimeValidator,
            trigger: "blur"
          }
        ],
        endTime: [
          {
            validator: endTimeValidator,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    let daysOfWeekList = srcDaysOfWeek();
    this.daysOfWeek = daysOfWeekList;
  },
  methods: {
    validateRow() {
      let validResult = false;
      this.$refs.scheduleForm.validate(valid => {
        validResult = valid;
      });
      return validResult;
    },
    onStartTimeFocus() {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.timesOfStartTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfStartTime.push(item);
        }
      });
    },
    onEndTimeFocus() {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.timesOfEndTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfEndTime.push(item);
        }
      });
    },
    dayChanged(value) {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id, valid);
      });
    },
    startTimeChanged(value) {
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id, valid);
      });
    },
    endTimeChanged(value) {
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id, valid);
      });
    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/campusTimeScheduleTimePicker.vue